module.exports = __webpack_public_path__ + "static/main_1-00d4614f09ece0616e75b08952498fed.jpg";